import * as angular from 'angular';

export default function ConfirmFactory($uibModal: angular.ui.bootstrap.IModalService, $confirmModalDefaults: any) {
    return function(data: any, settings: any) {
        settings = angular.extend($confirmModalDefaults, (settings || {}));
        data = data || {};

        if ('templateUrl' in settings && 'template' in settings) {
            delete settings.template;
        }

        settings.resolve = { data: () => data };

        return $uibModal.open(settings).result;
    };
}
ConfirmFactory.$inject = ['$uibModal', '$confirmModalDefaults'];
